<template>
  <div id="app">
    <toast v-for="(toast, index) in toasts" :key="index" :data="toast"></toast>
    <div v-if="$utils.getInternalAuthToken() != undefined" class="logged_in_body">
      <modals/>
      <daily-approve-message></daily-approve-message>
      <notice></notice>
      <recruiter-qa-drawer></recruiter-qa-drawer>
      <recruiter-qa-toast></recruiter-qa-toast>
      <left-menu></left-menu>
      <div id="right_column">
        <div id="main_title">
          <div>
            <img :src="$settings.get({ path: 'images' }).logo_dark" width="120px" />
          </div>
          <div class="vertical_separator"></div>
          <search-box></search-box>
          <paginate-navigation v-if="$route.meta.is_paginatable"></paginate-navigation>
        </div>
        <router-view :key="$route.fullPath" />
        <paginate-navigation style="margin-bottom: 30px;" v-if="$route.meta.is_paginatable"></paginate-navigation>
      </div>
    </div>
    <router-view v-else :key="$route.fullPath" />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { bus } from '@/custom/classes/bus.js'
import Firebase from '@/custom/classes/firebase.js'
import LeftMenu from '@/components/LeftMenu'
import Modals from '@/components/Modals'
import SearchBox from '@/components/SearchBox'
import PaginateNavigation from '@/components/PaginateNavigation'
import Notice from '@/components/Notice'
import DailyApproveMessage from '@/components/DailyApproveMessage'
import Toast from '@/components/Toast'
import RecruiterQaDrawer from '@/components/recruiterQa/RecruiterQaDrawer'
import RecruiterQaToast from '@/components/recruiterQa/RecruiterQaToast'

export default {
  name: 'app',
  data () {
    return {
      firebase: new Firebase(),
      toasts: [],
      has_page_per_navigation: false,
      handled_recruiter_question: null
    }
  },
  created: function () {
    this.listenToFirebase()
    this.setStyleSheet()
    this.setFavicon()
    this.listen()
    this.initRecruiterQa()
  },
  watch: {
    $route () {
      this.initRecruiterQa()
      this.$network_utils.setRouter(this.$route)
      let right_column = document.querySelector('#right_column')
      if (right_column != undefined) {
        right_column.scrollTo(0, 0)
      }
    }
  },
  methods: {
    listenToFirebase () {
      this.firebase.listenToMessages()
    },
    listen () {
      bus.$on('show_toast', data => {
        this.toasts.push(data)
      })
      window.addEventListener('mousemove', (event) => {
        this.setCursorX(event.clientX)
      })
    },
    setStyleSheet () {
      if (document.getElementById('main_stylesheet') != undefined) {
        return
      }
      let head = document.getElementsByTagName('head')[0]
      let link = document.createElement('link')
      link.id = 'main_stylesheet'
      link.rel = 'stylesheet'
      link.type = 'text/css'
      link.href = this.$settings.get({ path: 'stylesheet' })
      head.appendChild(link)
    },
    setFavicon () {
      // https://stackoverflow.com/questions/260857/changing-website-favicon-dynamically
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.$settings.get({ path: 'favicon' })
      document.getElementsByTagName('head')[0].appendChild(link)
    },
    // Recruiter Q&A: GET /config once after login (idempotent), then handle
    // the ?recruiter_question=<id> deep link (CEO Telegram DM).
    initRecruiterQa () {
      if (this.$utils.getInternalAuthToken() == undefined) {
        if (this.$store.state.recruiterQa.enabled) this.$store.dispatch('recruiterQa/reset')
        return
      }
      this.$store.dispatch('recruiterQa/init').then(() => {
        const id = this.$route.query.recruiter_question
        // The supervisor page consumes its own ?recruiter_question=<root_id>.
        if (this.$route.name === 'admin-recruiter-qa') return
        if (id == undefined || id == this.handled_recruiter_question) return
        this.handled_recruiter_question = id
        this.$store.dispatch('recruiterQa/openQuestion', { id })
      })
    },
    ...mapActions('general', ['setCursorX'])
  },
  components: {
    Modals,
    LeftMenu,
    SearchBox,
    PaginateNavigation,
    Notice,
    DailyApproveMessage,
    Toast,
    RecruiterQaDrawer,
    RecruiterQaToast
  }
}
</script>
<style>
.search_result_paint{
  background-color: #3273dc;
  color: white;
}
.boolean_question{
  display: inline-block;
  padding-top: 10px;
  padding-bottom: 10px;
}
.body_text_color{
  color: #4a4a4a;
}
.tooltip {
  position: relative;
  display: inline-block;
}
.has-border-none {
  border-style: hidden;
}
.tooltip .tooltiptext {
  visibility: hidden;

  max-width: 210px;
  min-width: 200px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 130%;
  left: 0;

  /* Fade in tooltip - takes 1 second to go from 0% to 100% opac: */
  opacity: 0;
  transition: opacity 1s;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 15px;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}
.search_results {
  position: relative;
  color: white;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}
.search_result {
  margin: 10px 0;
  border-radius: 30px;
  background-color: #f1f1f1;
  padding: 10px;
  color: #333;
  cursor: pointer;
}
.width_60px {
  width: 60px;
}
.has-background-warning-light {
  background-color: #fffaeb !important;
}
.search_result a {
  color: #333;
}
.search_result a:hover {
  color: #333;
}
.logged_in_body{
  height: 100%;
}
.is-warning{
  color: var(--color-text) !important;
  font-weight: bold;
  background-color: #ffb52b !important;
}
.pulse_animation_1{
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse_1 2s infinite;
}
.pulse_animation_2{
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulse_2 2s infinite;
}
@keyframes pulse_1 {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
@keyframes pulse_2 {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
.float-right {
  float: right
}
.search_by_container{
  display: inline-block;
  margin-top: 30px;
  margin-left: 30px;
}
.white_space_pre_line{
  white-space: pre-line;
}
.break_word{
  word-break: break-word;
}
.height_30px{
  height: 30px;
}
.width_30px{
  width: 30px;
}
.padding_0{
  padding: 0 !important;
}
.red_text{
  color: red;
}
.unauthorized_file {
  color: red !important;
  pointer-events: none;
}
.display_none{
  display: none;
}
.hide_visibility{
  visibility: hidden;
}
.file_error{
  color: red !important;
}
.file_checkbox {
  margin-left: 10px;
}
.file_link {
  border-color: transparent;
  border-radius: 18px;
  border: none;
  direction: rtl;
  background-color: rgba(0, 0, 0, 0.18);
  color: black;
  margin-left: 10px;
}
.file_margin{
  margin-bottom: 10px;
}
.file_link:after {
  content: "←";
}
.border-black {
  border: 2px solid black;
}
.is-green{
  background-color: transparent;
  border-color: green;
  color: green;
}
.is-green-fill {
  background-color: green;
  color: white;
}
.is-green:hover{
  border-color: transparent;
  background-color: green;
  color: white;
}
.status_color_text{
  display: inline-flex;
  max-width: 240px;
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: bold;
  padding: 6px 10px;
}
.offer-status-button {
  padding: 6px 10px;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.min_width_100_percent{
  min-width: 100%;
}
.min_width_138_px{
  min-width: 138px;
}
.full_width{
  width: 100%;
}
.full_height{
  height: 100%;
}
.display_inline_block{
  display: inline-block;
}
.display_inline{
  display: inline;
}
.display_table {
  display: table;
}
.margin_bottom_10px{
  margin-bottom: 10px;
}
.text_align_left{
  text-align: left;
}
.text_align_right{
  text-align: right;
}
.horizontal_space{
  width: 10px;
}
.is-revoked {
  border-color: red !important;
  background-color: rgba(255, 0, 0, 0.3) !important;
}
.skill_box {
  margin-left: 10px;
  margin-bottom: 10px;
  border: 1px solid #204d74;
  border-radius: 3px;
  padding: 3px;
}
.vertical_space{
  height: 10px;
}
.is-danger{
  background-color: #c9302c !important;
}
.is-danger.is-outlined{
  color: #c9302c !important;
  background-color: transparent !important;
  border-color: #c9302c !important;
}
.is-danger:hover{
  color: white !important;
  background-color: #c9302c !important;
}
.is-danger.is-loading{
  color: transparent !important;
}
.blue_text{
  color: #3273dc;
}
.blue_text:hover{
  color: #3273dc !important;
}
.margin_bottom_0{
  margin-bottom: 0;
}
.margin-left {
  margin: 10px;
}
.margin-right {
  margin-right: 10px;
}
.margin-top {
  margin-top: 10px;
}
.min-width-huge {
  min-width: 400px;
}
.min-width-large {
  min-width: 300px;
}
.min-width-medium {
  min-width: 200px;
}
.min-width-small {
  min-width: 100px;
}
.operations a, .operations img {
  display: block;
  margin-right: 6px;
}
.operation_icon {
  cursor: pointer;
}
.cursor_pointer {
  cursor: pointer;
}
.operation_icon img{
  min-width: 30px;
  width: 30px;
}
.width_50_percent{
  width: 50%;
}
.modal_form .router-links a {
  margin: 3px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  margin-right: 30px;
}
::-webkit-scrollbar-track {
  border-radius: 6px;
}
::-webkit-scrollbar-thumb {
  background: var(--color-scrollbar);
  border-radius: 6px;
}
:root {
  --left-column-width: 426px;
}
#app {
  height: 100%;
  min-height: 100%;
}
.faded{
  pointer-events: none;
  opacity: 0.6;
}
.btn{
  cursor: pointer;
}
a {
  color: white;
}
a:hover {
  color: white;
}
.router-links {
  text-align: left;
}
.router-links p {
  position: relative;
  display: inline-block;
}
.router-links p::after {
  height: 2px;
  background-color: var(--color-sub-text);
  opacity: 0;
  z-index: 100;
  display: block;
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  width: 0;
  margin: auto;
  transition: all .2s ease
}
.router-links p:hover:after {
  width: 100%;
  opacity: 1 !important;
  transition: all .1s ease;
}
.router-links p {
  margin: 0;
  cursor: pointer;
}
body,
html {
  margin: 0;
  padding: 0;
  min-height: 100%;
  background-color: white;
  font-family: "Poppins", sans-serif;
  height: 100%;
}
textarea.field_error, input.field_error, .field_error input[type="date"]{
  border: 1px solid;
  border-color: red !important;
}
input[type="range"] {
  -webkit-appearance: none;
  padding: 0 !important;
  width: 100%;
  height: 8px;
  border-radius: 5px;
  background: var(--color-main);
  outline: none;
  -webkit-transition: .2s;
  transition: opacity .2s;
}
input[type="range"]::-webkit-slider-thumb {
  outline: none;
  border-color: transparent;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--color-header);
  cursor: pointer;
}
input[type="range"]::-moz-range-thumb {
  outline: none;
  border-color: transparent;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--color-header);
  cursor: pointer;
}
input {
  padding-left: 20px !important;
  border: none;
  border-radius: 30px;
  padding: 10px;
  font-size: 18px;
  color: white;
}
.ltr {
  direction: ltr;
}
.rtl {
  direction: rtl;
}
textarea {
  direction: rtl;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  resize: none;
  min-width: 420px;
  min-height: 180px;
}
textarea:focus,
input:focus {
  outline: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="time"],
input[type="date"] {
  background-color: #f2f2f2;
  color: var(--color-text);
}
input.full::placeholder {
  color: white;
}
input.outlined::placeholder {
  color: #ccc;
}
input.full {
  background-color: var(--color-text);
  color: white;
}
input.outlined {
  border: 1px solid var(--color-text);
  color: var(--color-text);
}
select {
  background: url("/black_down_arrow.svg") no-repeat right #ddd;
  -webkit-appearance: none;
  appearance: none;
  background-size: 10px;
  background-position-x: calc(100% - 10px);
  border-radius: 30px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #f1f1f1;
  min-width: 180px;
  padding: 10px;
}
select[dir="ltr"]{
  background-position-x: calc(100% - 10px);
}
select[dir="rtl"]{
  background-position-x: 10px;
}
p {
  margin-top: 10px;
  margin-bottom: 10px;
}
img {
  display: block;
}
a.button {
  font-size: 14px;
}
.button.is-faded {
  opacity: 0.5;
  pointer-events: none;
}
.button.is-success {
  background-color: #48c78e;
}
.button.is-success:hover {
  background-color: #48c78e;
}
#right_column {
  position: relative;
  overflow: auto;
  float: right;
  width: calc(100% - var(--left-column-width));
  height: 100%;
}
#main_title {
  display: flex;
  align-items: center;
  background-color: #f6f6f6;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  height: 120px;
  width: 100%;
}
#main_title div {
  margin-left: 24px;
}
.black_border_bottom_width_2px{
  border-bottom: 2px solid rgba(0, 0, 0, 0.3) !important;
}
.white_border_bottom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.faded_border_bottom{
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.faded_border_top{
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.vertical_separator {
  position: relative;
  width: 2px;
  height: 60%;
  background-color: #ccc;
}
.horizontal_separator {
  position: relative;
  width: 100%;
  height: 2%;
  background-color: #ccc;
}
.max-width-300px {
  max-width: 300px;
}
.max-width-190px {
  max-width: 190px;
}
.height-250px {
  height: 250px;
}
.min-height-400 {
  min-height: 400px;
}
.break {
  flex-basis: 100%;
}
.text_align_center{
  text-align: center;
}
.sticky{
  position: sticky;
}
.relative {
  position: relative;
}
.center {
  position: relative;
  display: inline-block;
  left: 50%;
  top: -50%;
  transform: translate(-50%, 50%);
}
.center_horizontal {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.center_vertical {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.white_space_no_wrap{
  white-space: nowrap;
}
.card-title {
  margin: 0;
}
.card-title {
  margin-top: 10px;
  font-size: 30px;
}
.font-size-12 {
  font-size: 12px;
}
.medium_font_size {
  font-size: 20px;
}
.large_font_size {
  font-size: 25px;
}
.error_field{
  border-color: red !important;
}
.white {
  color: white;
}
.bold {
  font-weight: bold;
}
.card {
  border: 0;
  margin: 30px;
  margin-top: 10px;
  background-color: white;
  border-radius: 6px;
}
.card .card-body + .card-body {
  padding-top: 0;
}
.card.card-outline-success {
  border: 1px solid #08d419;
}
.card.card-outline-primary {
  border: 1px solid #1991eb;
}
.card.card-outline-warning {
  border: 1px solid #ffc105;
}
.card.card-outline-danger {
  border: 1px solid #ff0017;
}
.card.card-rounded {
  border-radius: 5px;
}
.card.card-faded {
  background: #b5b0b2;
  border-color: #b5b0b2;
}
.card.card-circle-progress {
  color: #ffffff;
  text-align: center;
}
.card-inverse-primary {
  background: rgba(25, 145, 235, 0.2);
  border: 1px solid #1785d8;
  color: #136eb3;
}
.card-inverse-secondary {
  background: rgba(222, 226, 230, 0.2);
  border: 1px solid #ccd0d4;
  color: #a9acaf;
}
.card-inverse-success {
  background: rgba(8, 212, 25, 0.2);
  border: 1px solid #07c317;
  color: #06a113;
}
.card-inverse-info {
  background: rgba(116, 90, 242, 0.2);
  border: 1px solid #6b53df;
  color: #5844b8;
}
.card-inverse-warning {
  background: rgba(255, 193, 5, 0.2);
  border: 1px solid #ebb205;
  color: #c29304;
}
.card-inverse-danger {
  background: rgba(255, 0, 23, 0.2);
  border: 1px solid #eb0015;
  color: #c20011;
}
.card-inverse-light {
  background: rgba(248, 249, 250, 0.2);
  border: 1px solid #e4e5e6;
  color: #bcbdbe;
}
.card-inverse-dark {
  background: rgba(66, 73, 100, 0.2);
  border: 1px solid #3d435c;
  color: #32374c;
}
.card-inverse-teal {
  background: rgba(88, 216, 163, 0.2);
  border: 1px solid #51c796;
  color: #43a47c;
}
.table {
  margin-bottom: 0;
}
.table tr.odd, .td_odd {
  background-color: #f2f2f2;
}
.td_even{
  background-color: white;
}
.width-170 {
  width: 170px;
}
th {
  text-transform: uppercase;
}
.table thead th {
  border-top: 0;
  border-bottom-width: 1px;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
}
.table thead th i {
  margin-left: 0.325rem;
}
.table td,
.table th {
  vertical-align: middle;
  font-size: 0.875rem;
  line-height: 1.3;
}
.table td img,
.table th img {
  max-width: 100%;
}
.table td .badge,
.table th .badge {
  margin-bottom: 0;
}
.table.table-borderless {
  border: none;
}
.table.table-borderless td,
.table.table-borderless th,
.table.table-borderless tr {
  border: none;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.table th,
.table td {
  padding: 1rem;
  /*vertical-align: top;*/
  /*border-top: 1px solid #f3f3f3;*/
}
.table thead th {
  text-align: left;
  font-weight: 7 00;
  vertical-align: bottom;
}
.table tbody + tbody {
  border-top: 2px solid #f3f3f3;
}
.table .table {
  background-color: #fff;
}
.table-sm th,
.table-sm td {
  padding: 0.3rem;
}
.table-bordered {
  border: 1px solid #f3f3f3;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #f3f3f3;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f6f8fa;
}
.table-hover tbody tr:hover {
  background-color: #f6f8fa;
}
.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #bfe0f9;
}
.table-hover .table-primary:hover {
  background-color: #a8d5f7;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #a8d5f7;
}
.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #f6f7f8;
}
.table-hover .table-secondary:hover {
  background-color: #e8eaed;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #e8eaed;
}
.table-success,
.table-success > th,
.table-success > td {
  background-color: #baf3bf;
}
.table-hover .table-success:hover {
  background-color: #a4efab;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #a4efab;
}
.table-info,
.table-info > th,
.table-info > td {
  background-color: #d8d1fb;
}
.table-hover .table-info:hover {
  background-color: #c4baf9;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #c4baf9;
}
.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #ffeeb9;
}
.table-hover .table-warning:hover {
  background-color: #ffe8a0;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #ffe8a0;
}
.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #ffb8be;
}
.table-hover .table-danger:hover {
  background-color: #ff9fa7;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #ff9fa7;
}
.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfdfe;
}
.table-hover .table-light:hover {
  background-color: #ececf6;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #ececf6;
}
.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #caccd4;
}
.table-hover .table-dark:hover {
  background-color: #bcbec9;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #bcbec9;
}
.table-teal,
.table-teal > th,
.table-teal > td {
  background-color: #d0f4e5;
}
.table-hover .table-teal:hover {
  background-color: #bbefda;
}
.table-hover .table-teal:hover > td,
.table-hover .table-teal:hover > th {
  background-color: #bbefda;
}
.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}
.table .thead-dark th {
  color: #fff;
  background-color: #212529;
  border-color: #32383e;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #f3f3f3;
}
.table-dark {
  color: #fff;
  background-color: #212529;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #32383e;
}
.table-dark.table-bordered {
  border: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.absolute {
  position: absolute;
}
.loading {
  height: 30px;
  width: 30px;
}
.loading:after {
  -webkit-animation: spinAround 0.6s infinite linear;
  animation: spinAround 0.6s infinite linear;
  border: 2px solid var(--color-main);
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 30px;
  width: 30px;
}
.modal_footer {
  box-shadow: 0px 10px 30px -3px rgba(0, 0, 0, 0.75);
  direction: ltr;
  position: fixed;
  background-color: white;
  left: 0;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  bottom: -62px;
  display: flex;
  padding: 10px;
  margin: 0 !important;
  justify-content: flex-start;
  align-items: center;
  border-top: 1px solid var(--color-main);
  width: 100%;
  height: 70px;
}
.main_button_color {
  border-color: var(--color-main);
  color: var(--color-main) !important;
}
.top_border {
  margin-top: 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 20px;
}
.slide-fade-enter-active {
  transition: all 0.6s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(60px);
  opacity: 0;
}
.fireworks_animation {
  position: absolute;
  width: -1;
  height: -1;
  border-radius: 50%;
  box-shadow: -120px -218.66667px blue, 248px -16.66667px #00ff84, 190px 16.33333px #002bff, -113px -308.66667px #ff009d, -109px -287.66667px #ffb300, -50px -313.66667px #ff006e, 226px -31.66667px #ff4000, 180px -351.66667px #ff00d0, -12px -338.66667px #00f6ff, 220px -388.66667px #99ff00, -69px -27.66667px #ff0400, -111px -339.66667px #6200ff, 155px -237.66667px #00ddff, -152px -380.66667px #00ffd0, -50px -37.66667px #00ffdd, -95px -175.66667px #a6ff00, -88px 10.33333px #0d00ff, 112px -309.66667px #005eff, 69px -415.66667px #ff00a6, 168px -100.66667px #ff004c, -244px 24.33333px #ff6600, 97px -325.66667px #ff0066, -211px -182.66667px #00ffa2, 236px -126.66667px #b700ff, 140px -196.66667px #9000ff, 125px -175.66667px #00bbff, 118px -381.66667px #ff002f, 144px -111.66667px #ffae00, 36px -78.66667px #f600ff, -63px -196.66667px #c800ff, -218px -227.66667px #d4ff00, -134px -377.66667px #ea00ff, -36px -412.66667px #ff00d4, 209px -106.66667px #00fff2, 91px -278.66667px #000dff, -22px -191.66667px #9dff00, 139px -392.66667px #a6ff00, 56px -2.66667px #0099ff, -156px -276.66667px #ea00ff, -163px -233.66667px #00fffb, -238px -346.66667px #00ff73, 62px -363.66667px #0088ff, 244px -170.66667px #0062ff, 224px -142.66667px #b300ff, 141px -208.66667px #9000ff, 211px -285.66667px #ff6600, 181px -128.66667px #1e00ff, 90px -123.66667px #c800ff, 189px 70.33333px #00ffc8, -18px -383.66667px #00ff33, 100px -6.66667px #ff008c;
  animation: 1s bang ease-out forwards 3, 1s gravity ease-in forwards 3, 5s position linear 3 forwards; }
@keyframes bang {
  from {
    box-shadow: 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white, 0 0 white; } }
@-webkit-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0; } }
@-moz-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0; } }
@-o-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0; } }
@-ms-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0; } }
@keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0; } }
@keyframes position {
  0%, 19.9% {
    width: 5px;
    height: 5px;
    margin-top: 10%;
    margin-left: 40%; }

  20%, 39.9% {
    width: 5px;
    height: 5px;
    margin-top: 40%;
    margin-left: 30%; }

  40%, 59.9% {
    width: 5px;
    height: 5px;
    margin-top: 20%;
    margin-left: 70%; }

  60%, 79.9% {
    width: 5px;
    height: 5px;
    margin-top: 30%;
    margin-left: 20%; }

  80%, 99.9% {
    width: 5px;
    height: 5px;
    margin-top: 30%;
    margin-left: 80%; }
  }
</style>
